import React, { useEffect, useState } from "react";
import PageContainer from "../components/admin/PageContainer";
import CollapseCard from "../components/admin/CollapseCard";
import Modal from "../components/admin/Modal";
import CustomerForm from "../components/admin/CustomerForm";
import CustomerList from "../components/admin/CustomerList";
import Main from "../components/admin/Main";
import {
  fetchCustomer,
  createCustomer,
  updateCustomer,
  deleteCustomer,
} from "../service/CustomerService";
import { ToastTypes, useToast } from "../components/toast/ToastProvider";

const CustomerPage = () => {
  const [showModal, setShowModal] = useState(false);
  const [customerData, setCustomerData] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const toast = useToast();

  const fetchData = async () => {
    try {
      const res = await fetchCustomer();
      setCustomerData(res);
    } catch (error) {
      console.error("Failed to fetch customers:", error);
      toast("Failed to load customers", ToastTypes.ERROR);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSaveCustomer = async (formData) => {
    try {
      if (selectedCustomer) {
        await updateCustomer(selectedCustomer.id, formData);
        toast("Customer updated successfully");
      } else {
        await createCustomer(formData);
        toast("Customer added successfully");
      }

      fetchData();
      setShowModal(false);
      setSelectedCustomer(null);
    } catch (error) {
      console.error("Failed to save customer:", error);
      toast("Failed to save customer", ToastTypes.ERROR);
    }
  };

const handleDelete = async (id) => {
  const confirmDelete = window.confirm("Are you sure you want to delete this customer?");
  if (!confirmDelete) return;

  try {
    await deleteCustomer(id);
    fetchData();
    toast("Customer deleted successfully");
  } catch (error) {
    console.error("Failed to delete customer:", error);
    toast("Failed to delete customer", ToastTypes.ERROR);
  }
};


  const handleEdit = (customer) => {
    setSelectedCustomer(customer);
    setShowModal(true);
  };

  return (
    <Main>
      <PageContainer
        title="Customer Page"
        buttonText="ADD"
        onButtonClick={() => {
          setSelectedCustomer(null);
          setShowModal(true);
        }}
      >
        <Modal
          visible={showModal}
          size="lg"
          onClose={() => {
            setShowModal(false);
            setSelectedCustomer(null);
          }}
          headerText={selectedCustomer ? "Edit Customer" : "Add Customer"}
          centered
        >
          <CustomerForm
            selectedData={selectedCustomer}
            onSave={handleSaveCustomer}
            onCancel={() => {
              setShowModal(false);
              setSelectedCustomer(null);
            }}
          />
        </Modal>

        <CollapseCard title="Customer List">
          <CustomerList
            customerData={customerData}
            onEdit={handleEdit}
            onDelete={handleDelete}
          />
        </CollapseCard>
      </PageContainer>
    </Main>
  );
};

export default CustomerPage;